var e = {
  Text: "text",
  //Text
  Directive: "directive",
  //<? ... ?>
  Comment: "comment",
  //<!-- ... -->
  Script: "script",
  //<script> tags
  Style: "style",
  //<style> tags
  Tag: "tag",
  //Any tag
  CDATA: "cdata",
  //<![CDATA[ ... ]]>
  Doctype: "doctype",
  isTag: function(t) {
    return t.type === "tag" || t.type === "script" || t.type === "style";
  }
};
export {
  e as d
};
//# sourceMappingURL=index.es26.js.map
